module.exports = __webpack_public_path__ + "img/2_7_1.f182a985.jpg";